module.exports = __webpack_public_path__ + "static/media/shapes_23.9e184e29.svg";